import React, { PropTypes } from 'react';
import Page from '../../components/layouts/Page';
import DashboardHeader from './DashboardHeader';

const FleetDashboardLayout = ({ children }) => {
  const dashboardType =
    children.props.route.dashboardType || children.props.params.dashtype;
  const dashboardDetails = {
    id: children.props.params.refid,
    dashboardType: children.props.params.dashtype.toLowerCase()
  };
  return (
    <div>
      <Page header withPbiEmbed>
        <DashboardHeader
          dashboardType={dashboardType}
          details={dashboardDetails}
        />
        {children}
      </Page>
    </div>
  );
};

FleetDashboardLayout.propTypes = {
  children: PropTypes.object
};

export default FleetDashboardLayout;



// WEBPACK FOOTER //
// ./src/layouts/fleet/FleetDashboardLayout.js